import { constants } from '@pukka/common';
import { mock } from 'universal-mock';
import { UnleashClient, IConfig } from 'unleash-proxy-client';

import { flags, FlagNames } from './featureFlagConfig';

const { UNLEASH_APP_NAME, UNLEASH_CLIENT_KEY, UNLEASH_URL } = constants;

class SafeUnleashClient extends UnleashClient {
  public isReady: boolean;

  public constructor(config: IConfig) {
    super(config);
    this.isReady = false;
    this.on('ready', () => {
      this.isReady = true;
    });
  }

  getVariantWithFallback(toggleName: FlagNames) {
    return this.isReady ? this.getVariant(toggleName) : flags[toggleName].variant;
  }

  isEnabledWithFallBack(toggleName: FlagNames) {
    return this.isReady ? this.isEnabled(toggleName) : flags[toggleName].enabled;
  }
}

const singleton: {
  unleash: UnleashClient | undefined;
} = {
  unleash: undefined,
};

const getUnleashClient = (
  Singleton: typeof singleton = singleton,
  SafeUnleashClientClass: typeof SafeUnleashClient = SafeUnleashClient,
): SafeUnleashClient => {
  return (
    Singleton.unleash ??
    (() => {
      try {
        Singleton.unleash = new SafeUnleashClientClass({
          url: UNLEASH_URL,
          clientKey: UNLEASH_CLIENT_KEY,
          appName: UNLEASH_APP_NAME,
          refreshInterval: 0,
          disableMetrics: true,
        });

        return Singleton.unleash;
      } catch (e) {
        console.warn('Unable to initialize unleash');

        return mock;
      }
    })()
  );
};

export { getUnleashClient, SafeUnleashClient as _SafeUnleashClient };
